import { useCallback, useState } from 'react';

const STORAGE_KEY = '@live-map-layers';
// Pre-toggles flag, kept only as the initial value for the destinations layer.
const LEGACY_DESTINATIONS_KEY = '@order-address-markers';

export const MAP_LAYERS = {
	DELIVERIES: 'deliveries',
	SHOPS: 'shops',
	DESTINATIONS: 'destinations',
	TRAFFIC: 'traffic',
};

const readStoredLayers = () => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

/**
 * Which pin sets the Live map draws. Per browser, not per city — the city
 * settings only seed the defaults until the user touches a toggle.
 */
export const useMapLayers = user => {
	const [layers, setLayers] = useState(() => ({
		[MAP_LAYERS.DELIVERIES]: true,
		[MAP_LAYERS.SHOPS]: !!user?.cityLocation?.withShowShopPins,
		[MAP_LAYERS.DESTINATIONS]: localStorage.getItem(LEGACY_DESTINATIONS_KEY) === 'y',
		[MAP_LAYERS.TRAFFIC]: false,
		...(readStoredLayers() || {}),
	}));

	const toggleLayer = useCallback(key => {
		setLayers(prev => {
			const next = { ...prev, [key]: !prev[key] };
			try {
				localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
			} catch {
				// private mode / full storage — the toggle still works for this session
			}
			return next;
		});
	}, []);

	return { layers, toggleLayer };
};
